import "./Footer.css";
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react'; // Импортируем хуки для работы с Auth0



const Footer = () => {

  const { isAuthenticated, loginWithRedirect } = useAuth0(); // Получаем статус авторизации и функцию входа


  return (
    <div id="footer">
      <div className="footer">
        <div className="ilike">
          <p>Если сайт Вам понравился и оказался для Вас полезным, то поделитесь им.</p>
          <div className="ilike_but_top">

          {isAuthenticated ? (
        <Link
          to="/lk"
          className="demo_but_r"
          aria-label="Перейти в Личный кабинет"
          title="Перейти в Личный кабинет"
        />
      ) : (
        <button
          className="demo_but_r"
          onClick={() => loginWithRedirect()}
          aria-label="Войти в Личный кабинет"
          title="Войти в Личный кабинет"
          role="button"
        />
      )}

          </div>

        </div>
        <div className="copy"><p>Все права защищены Ⓒ 2011-2025 Официальный сайт Сергея Мавроди</p></div>
      </div>
    </div>
  );
};

export default Footer;